if (!customElements.get('wlsn-accessories-buybox')) {
  class WLSNAccessoriesBuybox extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        activeClass: 'is-active',
        disabledClass: 'disabled',
        quantityIncrease: 'js-wlsn-accessories-buybox-qty-btn-increase',
        quantityDecrease: 'js-wlsn-accessories-buybox-qty-btn-decrease',
        quantityInput: 'js-wlsn-accessories-buybox-quantity-input',
        quantityAtc: 'js-wlsn-accessories-buybox-atc',
        sellingPlan: 'js-wlsn-accessories-buybox-selling-plan',
        selectedSellingPlan: 'js-wlsn-accessories-buybox-selling-plan.is-active',
        buyboxButtonWrapper: 'js-wlsn-accessories-buybox-button-wrapper',
        variantOption: 'js-wlsn-accessories-buybox-variant-option',
        variantImage: 'js-wlsn-accessories-buybox-variant-image',
        productPrice: 'js-wlsn-accessories-buybox-price',
        variantsWrapper: 'js-wlsn-accessories-buybox-variants',
        sellingPlanInput: 'input[name="selling_plan"]',
        gallerySlider: 'js-wlsn-slider',
        galleryImage: 'wlsn-accessories-buybox__slider-img',
        subscriptionTab: 'js-wlsn-accessories-buybox-subscription-tab',
        selectedSubscriptionTab: '.js-wlsn-accessories-buybox-subscription-tab.is-selected',
        subscriptionTitle: '.js-wlsn-subscription-title-value',
        subscriptionWrapper: 'wlsn-accessories-buybox__subscriptions-wrapper',

      };

      this.setElements();
      this.requestCounter = 0;
      this.abortController = null;
      this.variantCache = new Map();

      this.drawer;

      this.selectedState = {
        optionId: this.getSelectedVariantOptionIds() || null,
        quantityId: this.elements.selectedSellingPlan?.dataset.optionId || null
      };
    }

    getSelectedVariantOptionIds() {
      return Array.from(this.querySelectorAll(`.${this.classes.variantOption}:checked`))
        .map((input) => input.value)
        .filter(Boolean)
        .join(',');
    }

    onVariantOptionChange = (e) => {
      const input = e.target;

      if (!input.matches?.(`.${this.classes.variantOption}`) || input.type !== 'radio' || !input.checked) {
        return;
      }

      this.disableBuyboxButtonWrapper();
      this.selectedState.optionId = this.getSelectedVariantOptionIds() || null;
      this.updateVariants();
    };

    connectedCallback() {
      if (!this._variantChangeBound) {
        this._variantChangeBound = true;
        this.addEventListener('change', this.onVariantOptionChange);
      }

      this.init();
      this.drawer = document.querySelector('wlsn-cart-drawer');

      this.syncGalleryWithSelectedVariant();
    }

    disconnectedCallback() {
      if (this._pageShowBound) {
        window.removeEventListener('pageshow', this.handlePageShow);
        this._pageShowBound = false;
      }

      if (this._variantChangeBound) {
        this.removeEventListener('change', this.onVariantOptionChange);
        this._variantChangeBound = false;
      }
    }

    init() {
      this.setupQuantityButtons();
      this.setupAddToCart();
      this.handleEventListeners();
      this.handleSubscriptionTabs();
      this.syncInitialSubscriptionState();

      if (
        this.elements.sellingPlans.length > 0 &&
        this.elements.variantOptions.length > 0 &&
        (!this.selectedState.quantityId || !this.selectedState.optionId)
      ) {
        this.disableBuyboxButtonWrapper();
      }

      if (!this._pageShowBound) {
        this._pageShowBound = true;
        window.addEventListener('pageshow', this.handlePageShow);
      }
    }

    handlePageShow = () => {
      const selected = this.getSelectedVariantOptionIds();

      if (!selected) return;

      this.selectedState.optionId = selected;
      this.syncGalleryWithSelectedVariant();
      this.updateVariants();
    };

    handleEventListeners() {
      this.elements.sellingPlans.forEach(plan => {
        if (plan.dataset.wlsnAccessoriesBuyboxBound === 'true') return;

        plan.dataset.wlsnAccessoriesBuyboxBound = 'true';

        plan.addEventListener('click', () => {
          plan.parentElement.querySelectorAll(`.${this.classes.activeClass}`).forEach(el =>
            el.classList.remove(this.classes.activeClass)
          );

          plan.classList.add(this.classes.activeClass);
          this.selectedState.quantityId = plan.dataset.optionId;

          this.disableBuyboxButtonWrapper();
          this.updateVariants();
        });
      });
    }

    setupQuantityButtons() {
      if (this.elements.quantityIncrease && this.elements.quantityIncrease.dataset.wlsnAccessoriesBuyboxBound !== 'true') {
        this.elements.quantityIncrease.dataset.wlsnAccessoriesBuyboxBound = 'true';
        this.elements.quantityIncrease.addEventListener('click', () => this.changeQuantity(1));
      }

      if (this.elements.quantityDecrease && this.elements.quantityDecrease.dataset.wlsnAccessoriesBuyboxBound !== 'true') {
        this.elements.quantityDecrease.dataset.wlsnAccessoriesBuyboxBound = 'true';
        this.elements.quantityDecrease.addEventListener('click', () => this.changeQuantity(-1));
      }
    }

    changeQuantity(delta) {
      const currentValue = parseInt(this.elements.quantityInput.value, 10) || 1;
      const newValue = Math.max(1, currentValue + delta);

      this.elements.quantityInput.value = newValue;

      if (this.elements.quantityAtc) {
        this.elements.quantityAtc.dataset.quantity = newValue;
      }
    }

    setupAddToCart() {
      if (!this.elements.quantityAtc || this.elements.quantityAtc.dataset.wlsnAccessoriesBuyboxBound === 'true') return;

      this.elements.quantityAtc.dataset.wlsnAccessoriesBuyboxBound = 'true';

      this.elements.quantityAtc.addEventListener('click', async (e) => {
        e.preventDefault();

        const data = {
          id: this.elements.quantityAtc.dataset.id,
          quantity: this.elements.quantityAtc.dataset.quantity || 1,
          selling_plan: this.elements.sellingPlanInput?.value || null
        };

        try {
          const addResponse = await fetch(`${window.location.origin}/cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
          });
        
          if (!addResponse.ok) {
            console.error('Add to cart failed:', addResponse);
            return;
          }
        
          if (window.cartType === 'cart_drawer') {
            this.drawer?.openDrawer();
            this.drawer?.setLoading(true);
            await this.drawer?.refreshDrawer();
            return;
          }
        
          window.location.href = window.location.origin + '/checkout?skip_shop_pay=true';
        } catch (err) {
          console.error('ATC error:', err);
        }
      });
    }

    getOptionValuesQuery() {
      return [
        this.selectedState.optionId,
        this.selectedState.quantityId
      ]
        .filter(value => value && value !== 'null' && value !== 'undefined')
        .join(',');
    }

    updateVariants() {

      const start = performance.now();
      
      const currentRequest = ++this.requestCounter;
      const query = this.getOptionValuesQuery();
    
      if (!query) return;

      if (this.abortController) {
        this.abortController.abort();
      }
      
      this.abortController = new AbortController();
    
      fetch(
        `${window.location.pathname}?option_values=${query}`,
        {
          signal: this.abortController.signal
        }
      )
        .then(res => res.text())
        .then(html => {
        
          if (currentRequest !== this.requestCounter) return;
    
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
    
          const newButtonWrapper = doc.querySelector(`.${this.classes.buyboxButtonWrapper}`);
          const newPrice = doc.querySelector(`.${this.classes.productPrice}`);
          const newVariantsWrapper = doc.querySelector(`.${this.classes.variantsWrapper}`);
    
          const currentButtonWrapper = this.querySelector(`.${this.classes.buyboxButtonWrapper}`);
          const currentPrice = this.querySelector(`.${this.classes.productPrice}`);
          const currentVariantsWrapper = this.querySelector(`.${this.classes.variantsWrapper}`);

          const newSubscriptionWrapper = doc.querySelector(`.${this.classes.subscriptionWrapper}`);
          
          const currentSubscriptionWrapper = this.querySelector(`.${this.classes.subscriptionWrapper}`);
    
          if (newVariantsWrapper && currentVariantsWrapper) {
            currentVariantsWrapper.innerHTML = newVariantsWrapper.innerHTML;
          }
    
          if (newPrice && currentPrice) {
            currentPrice.innerHTML = newPrice.innerHTML;
          }

          if (newSubscriptionWrapper && currentSubscriptionWrapper) {
            currentSubscriptionWrapper.innerHTML =
              newSubscriptionWrapper.innerHTML;
          }
    
          if (newButtonWrapper && currentButtonWrapper) {
            currentButtonWrapper.innerHTML = newButtonWrapper.innerHTML;
    
            if (this.selectedState.optionId) {
              currentButtonWrapper.classList.remove(this.classes.disabledClass);
            }
    
            this.setElements();

            this.selectFirstAvailableSubscriptionTab();
            this.init();
            this.updateURL();
    
            this.syncGalleryWithSelectedVariant();
          }
        })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error fetching HTML:', err);
          }
        });
    }

    syncGalleryWithSelectedVariant() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const selectedInput = this.querySelector(`.${this.classes.variantOption}:checked`);

          if (!selectedInput) return;

          this.setActiveGalleryImageFromVariantInput(selectedInput);
        });
      });
    }

    setActiveGalleryImageFromVariantInput(input, attempt = 0) {
      const label = this.querySelector(`label[for="${this.escapeSelector(input.id)}"]`);
      const variantImage = label?.querySelector(`.${this.classes.variantImage}`);

      if (!variantImage) return;

      const variantFileName = this.getImageFileName(variantImage);

      if (!variantFileName) return;

      const galleryImages = Array.from(this.querySelectorAll(`.${this.classes.galleryImage}`));

      const matchedImage = galleryImages.find(image => {
        const galleryFileName = this.getImageFileName(image);

        return galleryFileName && galleryFileName === variantFileName;
      });

      if (!matchedImage) return;

      const matchedSlide = matchedImage.closest('.swiper-slide');

      if (!matchedSlide) return;

      const gallerySlider = matchedSlide.closest(`.${this.classes.gallerySlider}`);
      const swiper = gallerySlider?.swiper;

      if (!swiper) {
        if (attempt < 20) {
          requestAnimationFrame(() => {
            this.setActiveGalleryImageFromVariantInput(input, attempt + 1);
          });
          return;
        }

        matchedSlide.classList.add(this.classes.activeClass);
        matchedSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        return;
      }

      const slideIndex = Array.from(swiper.slides).indexOf(matchedSlide);

      if (slideIndex < 0) return;

      if (swiper.params?.loop && typeof swiper.slideToLoop === 'function') {
        const realIndex = Number(matchedSlide.dataset.swiperSlideIndex);

        if (!Number.isNaN(realIndex)) {
          swiper.slideToLoop(realIndex);
          return;
        }
      }

      swiper.slideTo(slideIndex);
    }

    getImageFileName(image) {
      const imageUrl =
        image.currentSrc ||
        image.src ||
        this.getFirstSrcFromSrcset(image.srcset);

      if (!imageUrl) return null;

      try {
        const url = new URL(imageUrl, window.location.origin);
        const pathname = decodeURIComponent(url.pathname);
        const fileName = pathname.split('/').pop();

        if (!fileName) return null;

        return fileName
          .replace(/\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i, '')
          .replace(/_(\d+)x(\d+|progressive)?(@2x)?$/i, '')
          .replace(/_\d+x$/i, '')
          .toLowerCase();
      } catch (err) {
        return imageUrl
          .split('?')[0]
          .split('/')
          .pop()
          ?.replace(/\.(jpg|jpeg|png|webp|gif|avif)$/i, '')
          .replace(/_(\d+)x(\d+|progressive)?(@2x)?$/i, '')
          .replace(/_\d+x$/i, '')
          .toLowerCase() || null;
      }
    }

    getFirstSrcFromSrcset(srcset) {
      if (!srcset) return null;

      return srcset
        .split(',')
        .map(src => src.trim().split(' ')[0])
        .filter(Boolean)[0] || null;
    }

    escapeSelector(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }

      return value.replace(/"/g, '\\"');
    }

    updateURL() {
      const query = this.getOptionValuesQuery();
      const params = new URLSearchParams(window.location.search);
    
      if (query) {
        params.set('option_values', query);
      } else {
        params.delete('option_values');
      }
    
      const queryString = params.toString();
      const newUrl = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;
    
      window.history.pushState({}, '', newUrl);
    }

    disableBuyboxButtonWrapper() {
      this.elements.buyboxButtonWrapper?.classList.add(this.classes.disabledClass);
    }

    handleSubscriptionTabs() {
      this.elements.subscriptionTabs.forEach(tab => {
        tab.addEventListener('click', () => {
    
          this.elements.subscriptionTabs.forEach(item => {
            item.classList.remove('is-selected');
          });
    
          tab.classList.add('is-selected');
    
          const sellingPlanId = tab.dataset.sellingPlan || '';
    
          if (this.elements.sellingPlanInput) {
            this.elements.sellingPlanInput.value = sellingPlanId;
          }
    
          if (this.elements.subscriptionTitle) {
            this.elements.subscriptionTitle.textContent = tab.dataset.title;
          }
    
          const priceEl = this.querySelector('.js-wlsn-accessories-buybox-price');
    
          if (priceEl) {
            const price = tab.dataset.price;
            const comparePrice = tab.dataset.comparePrice;
    
            priceEl.innerHTML = comparePrice
              ? `<s>${comparePrice}</s> ${price}`
              : price;
          }
    
        });
      });
    }

    syncInitialSubscriptionState() {
      const selectedTab = this.querySelector(
        '.js-wlsn-accessories-buybox-subscription-tab.is-selected'
      );
    
      if (!selectedTab) return;
    
      const priceEl = this.querySelector('.js-wlsn-accessories-buybox-price');
    
      if (priceEl) {
        const price = selectedTab.dataset.price;
        const comparePrice = selectedTab.dataset.comparePrice;
    
        priceEl.innerHTML = comparePrice
          ? `<s>${comparePrice}</s> ${price}`
          : price;
      }
    
      const input = this.elements.sellingPlanInput;
      if (input) {
        input.value = selectedTab.dataset.sellingPlan || '';
      }
    
      const titleEl = this.elements.subscriptionTitle;
      if (titleEl) {
        titleEl.textContent = selectedTab.dataset.title || '';
      }
    }

    selectFirstAvailableSubscriptionTab() {
      const availableTab = [...this.elements.subscriptionTabs].find(
        tab => !tab.classList.contains('is-disabled')
      );
    
      if (!availableTab) return;
    
      this.elements.subscriptionTabs.forEach(tab => {
        tab.classList.remove('is-selected');
      });
    
      availableTab.classList.add('is-selected');
    
      if (this.elements.sellingPlanInput) {
        this.elements.sellingPlanInput.value =
          availableTab.dataset.sellingPlan || '';
      }
    
      if (this.elements.subscriptionTitle) {
        this.elements.subscriptionTitle.textContent =
          availableTab.dataset.title || '';
      }
    
      const priceEl = this.querySelector('.js-wlsn-accessories-buybox-price');
    
      if (priceEl) {
        const price = availableTab.dataset.price;
        const comparePrice = availableTab.dataset.comparePrice;
    
        priceEl.innerHTML = comparePrice
          ? `<s>${comparePrice}</s> ${price}`
          : price;
      }
    }

    setElements() {
      this.elements = {
        quantityIncrease: this.querySelector(`.${this.classes.quantityIncrease}`),
        quantityDecrease: this.querySelector(`.${this.classes.quantityDecrease}`),
        quantityInput: this.querySelector(`.${this.classes.quantityInput}`),
        quantityAtc: this.querySelector(`.${this.classes.quantityAtc}`),
        sellingPlans: this.querySelectorAll(`.${this.classes.sellingPlan}`),
        selectedSellingPlan: this.querySelector(`.${this.classes.selectedSellingPlan}`),
        buyboxButtonWrapper: this.querySelector(`.${this.classes.buyboxButtonWrapper}`),
        variantOptions: this.querySelectorAll(`.${this.classes.variantOption}`),
        productPrice: this.querySelector(`.${this.classes.productPrice}`),
        sellingPlanInput: this.querySelector(`${this.classes.sellingPlanInput}`),
        subscriptionTabs: this.querySelectorAll(`.${this.classes.subscriptionTab}`),
        selectedSubscriptionTab: this.querySelector(this.classes.selectedSubscriptionTab),
        subscriptionTitle: this.querySelector(this.classes.subscriptionTitle),
        subscriptionWrapper: this.querySelector(this.classes.subscriptionWrapper),

      };
    }
  }

  customElements.define('wlsn-accessories-buybox', WLSNAccessoriesBuybox);
}